/**
 * Compare two values deeply
 * @param {any} a
 * @param {any} b
 * @param {boolean} opts.orderMatters - Whether to consider order of arrays
 * @returns {boolean}
 */
export const compareDeep = (a, b, opts = {}) => {
  if (a === b) {
    return true;
  }
  if (typeof a !== 'object' || a === null || typeof b !== 'object' || b === null) {
    return false;
  }

  if (Array.isArray(a) && Array.isArray(b)) {
    if (a.length !== b.length) {
      return false;
    }
    if (opts?.orderMatters) {
      for (let i = 0; i < a.length; i++) {
        if (!compareDeep(a[i], b[i], opts)) {
          return false;
        }
      }
    } else {
      const visited = new Array(b.length).fill(false);
      for (let i = 0; i < a.length; i++) {
        let matched = false;
        for (let j = 0; j < b.length; j++) {
          if (!visited[j] && compareDeep(a[i], b[j], opts)) {
            visited[j] = true;
            matched = true;
            break;
          }
        }
        if (!matched) {
          return false;
        }
      }
    }
    return true;
  }

  if (Array.isArray(a) || Array.isArray(b)) {
    return false;
  }

  const keysA = Object.keys(a);
  const keysB = Object.keys(b);
  if (keysA.length !== keysB.length) {
    return false;
  }
  for (const key of keysA) {
    if (!Object.prototype.hasOwnProperty.call(b, key) || !compareDeep(a[key], b[key], opts)) {
      return false;
    }
  }
  return true;
};
